namespace GeniuzPOS.Administration {
    export class PoApprovalGroupColumns {
        static columnsKey = 'Administration.PoApprovalGroup';
    }
}
